import axios from 'axios';

const { REACT_APP_API_HOST: API_HOST } = process.env;

// GET /v1/people returns 10 people unless told otherwise, and the pickers
// asked for 10, 100 or 200, so anyone past that was missing from them.
const PAGE_SIZE = 100;
// A backstop against looping forever if the API ignores `page`.
const MAX_PAGES = 100;

export type PeopleResponse<T = any> = {
  status?: string;
  data: T[];
  count: number;
};

/**
 * Every person in the caller's company matching `filters` (office, team,
 * search), fetched page by page. Resolves to the same shape as one
 * GET /v1/people response, with all rows in `data`.
 */
export async function fetchAllPeople<T = any>(
  filters: Record<string, unknown> = {},
): Promise<PeopleResponse<T>> {
  const people: T[] = [];
  let status: string | undefined;

  for (let page = 0; page < MAX_PAGES; page += 1) {
    const { data: body } = await axios.get(`${API_HOST}/v1/people`, {
      params: { ...filters, page, limit: PAGE_SIZE },
    });
    const rows: T[] = Array.isArray(body?.data) ? body.data : [];
    status = body?.status ?? status;
    people.push(...rows);

    const total = Number(body?.count);
    const reachedTotal = Number.isFinite(total) && people.length >= total;
    if (rows.length < PAGE_SIZE || reachedTotal) {
      break;
    }
  }

  return { status, data: people, count: people.length };
}

const getEmployees = (): Promise<any> => fetchAllPeople();

const employees = {
  getEmployees,
}; 

export default employees;